import { apiURL } from "../../config";

export const getQuestionSuggestions = async (axiosPrivate, phrase) => {
	try {
		const response = await axiosPrivate.get(`${apiURL}/decision/question-suggestions.json?phrase=${encodeURIComponent(phrase)}`);
		return response.data;
	} catch (error) {
		console.error("Error fetching question suggestions:", error);
		return [];
	}
};
